// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gPbJ","col":"styles_col__3chOX"};